import React, {useMemo, useRef} from "react";
import {useVehicleList} from "~/apps/packages/auto-visits/hooks";
import {Autocomplete, AutocompleteProps, Box, ListItem} from '@mui/material';
import {TextField, TextFieldProps} from "@mui/material";
import {humanizeVehicleNumber} from "~/apps/core/ui/VehicleNumber";
import {ArrayElement} from "~/types";
import {compareByField, distinctByField} from "~/apps/core/utils";
import {useCarrierList, useContractList} from "~/apps/packages/auto-shipment-orders/hooks";
import {Carrier, Contract} from "~/apps/packages/auto-shipment-orders/queries";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";

type ExtendedCarrierType = Carrier & { group: 'a' | 'b' }

export type ContractSelectProps = {
    value?: Carrier
    onChange?: (value: Carrier) => any
} & Omit<TextFieldProps, "value" | "onChange">;

const useStyles = makeStyles<PortTheme>((theme) => ({
    option: {
        fontSize: "12px!important",
        lineHeight: "20px!important",
        height: 'auto!important',
        padding: '12px 10px!important',
        position: 'relative',
        '&:not(:first-child):before': {
            content: '""',
            width: 'calc(100% - 20px)',
            position: 'absolute',
            top: 0,
            left: 10,
            borderTop: '1px solid rgba(110, 121, 140, 0.07)'
        }
    },
    divider: {
        height: '1px',
        width: 'calc(100% - 20px)',
        position: 'relative',
        left: 10,
        background: 'rgba(182, 187, 197, 0.50)',
        '& + li': {
            '&:before': {
                content: "none!important"
            }
        }
    }
}))

export const CarrierSelect = (props: ContractSelectProps) => {
    const {onChange, value, ...otherProps} = props;
    const {data} = useCarrierList();

    const styles = useStyles();

    const inputRef = useRef<HTMLInputElement>();
    const loading = !data;
    const handleChange = (e:  React.SyntheticEvent, value: Carrier) => {
        // const value = availableValues.find(item => item.id == e.target.value);

        onChange && onChange(value);
    }

    const availableValues = useMemo(() => {
        let availableValues: ExtendedCarrierType[] = [];
        data?.carriers?.map((item) => availableValues.push({...item, group: 'a'}));
        data?.additionalCarriers?.map((item) => availableValues.push({...item, group: 'b'}))
        return distinctByField(availableValues, "id").sort(compareByField("name")).sort(compareByField('group'));
    }, [data]);

    return (
        <Autocomplete
            {...otherProps as any as AutocompleteProps<Carrier, any, any, any>}
            value={value}
            onChange={handleChange}
            renderInput={props => (
                <TextField {...props} inputRef={inputRef} label="Перевозчик" placeholder="Выбрать"/>
            )}
            renderGroup={(params) => (
                <>
                    {params.group === 'b'
                        && <Box className={styles.divider}/>
                    }
                    {params.children}
                </>
            )}
            getOptionLabel={(option: Carrier) => option.name}
            groupBy={(option: ExtendedCarrierType) => option.group}
            isOptionEqualToValue={(option: Carrier, value: Carrier) => value.name == option.name}
            options={availableValues}
            loading={loading}
            noOptionsText="Не найдено"
            loadingText="Загрузка..."
            blurOnSelect
            classes={{option: styles.option}}
        />
    );
}
